import $ from 'jquery';


function accordion() {
    $('.accordion').each(function () {
        const $accordion = $(this);
        const $items = $accordion.find('.accordion-item');
        const $headers = $items.find('.accordion-header');

        $headers.on('click', function () {
            const $header = $(this);
            const $item = $header.closest('.accordion-item');
            const $content = $item.find('.accordion-content');

            if ($item.hasClass('active')) {
                $item.removeClass('active');
                $content.slideUp(300);
            } else {
                // Close other items
                $items.removeClass('active');
                $items.find('.accordion-content').slideUp(300);

                // Open the clicked item
                $item.addClass('active');
                $content.slideDown(300);
            }
        });
    });
}

export { accordion };